<template>
    <div v-if="!termoAceitePoliticaPrivacidade" class="modal d-flex w-75">
      <div class="d-flex w-100 p-3" style="justify-content:space-between">
        <h6>Nosso site utiliza cookies para melhorar sua experiência de navegação. Continuando a navegar você aceita nossa <a href="#" target="_blank" rel="noopener noreferrer">Política de Privacidade</a> </h6>
        <b-button variant="outline-success" size="sm" @click="aceitar">Entendi</b-button>
      </div>
    </div>
</template>
<script>

export default {
  name: 'ModalPoliticasDePrivacidade',
  data () {
    return {
      css: ' ',
      termoAceitePoliticaPrivacidade: false
    }
  },
  created () {
    this.setaTermoAceitePoliticaPrivacidade()
  },
  methods: {
    setaTermoAceitePoliticaPrivacidade () {
      const termoAceitePoliticaPrivacidade = localStorage.getItem('termoAceitePoliticaPrivacidade')

      if (termoAceitePoliticaPrivacidade) {
        this.termoAceitePoliticaPrivacidade = termoAceitePoliticaPrivacidade
      }
    },

    aceitar () {
      this.termoAceitePoliticaPrivacidade = true
      localStorage.setItem('termoAceitePoliticaPrivacidade', true)
    }
  }
}
</script>

<style scoped>
.modal{
    position: fixed;
    left: 15px;
    top: 90%;
    transition: all ease 0.4s;
    border: 3px solid black;
    z-index: 99999;
    background: rgb(0, 0, 0);
    color: white;
    height: 8%;
  }

  .aceitar{
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/ModalPoliticasDePrivacidade.vue